<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de ofertas mais vendidas
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-indicadores-marketplace-lista-ofertas
          :ofertas="ofertas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import IndicadoresMarketplace from '../indicadores-marketplace';
import IndicadoresMarketplaceListaOfertas from './IndicadoresMarketplaceListaOfertas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.dataMes.initialDate} and dataCompra <= ${this.dataMes.finalDate}`;
    },
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    onClickRefresh() {
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getOfertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return IndicadoresMarketplace.getOfertas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dataMes(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.resetPage();
      this.onClickRefresh();
    },
  },
  components: {
    pxIndicadoresMarketplaceListaOfertas: IndicadoresMarketplaceListaOfertas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
